import React, { useState, useEffect } from 'react';
import api from '../../api/axios';

const colors = [
  { value: 'badge-primary', label: 'Azul' },
  { value: 'badge-success', label: 'Verde' },
  { value: 'badge-warning', label: 'Amarillo' },
  { value: 'badge-danger', label: 'Rojo' },
  { value: 'badge-info', label: 'Cyan' },
  { value: 'badge-secondary', label: 'Gris' },
];

const ActivityTypes = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ name: '', color: 'badge-primary' });

  const fetchTypes = async () => {
    try {
      const res = await api.get('/activity-types');
      setTypes(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchTypes(); }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleNew = () => {
    setEditing(null);
    setForm({ name: '', color: 'badge-primary' });
    setShowForm(true);
  };

  const handleEdit = (type) => {
    setEditing(type);
    setForm({ name: type.name, color: type.color });
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditing(null);
    setForm({ name: '', color: 'badge-primary' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      if (editing) {
        await api.put(`/activity-types/${editing.id}`, form);
      } else {
        await api.post('/activity-types', form);
      }
      handleCancel();
      fetchTypes();
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Desactivar este tipo de actividad?')) return;
    try {
      await api.delete(`/activity-types/${id}`);
      fetchTypes();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container-fluid">
      <div className="page-header d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Tipos de Actividad</h4>
        <button className="btn btn-primary" onClick={handleNew}>
          <i className="ti-plus mr-2"></i> Nuevo Tipo
        </button>
      </div>

      {showForm && (
        <div className="card mb-4">
          <div className="card-header">
            <h6 className="mb-0">{editing ? 'Editar Tipo' : 'Nuevo Tipo'}</h6>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Nombre <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Color</label>
                    <select name="color" className="form-control" value={form.color} onChange={handleChange}>
                      {colors.map((c) => (
                        <option key={c.value} value={c.value}>{c.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-2 d-flex align-items-end">
                  <div className="form-group">
                    <label>Vista previa</label>
                    <div>
                      <span className={`badge ${form.color}`}>{form.name || 'Ejemplo'}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" className="btn btn-primary btn-sm mr-2" disabled={submitting}>
                {submitting ? 'Guardando...' : 'Guardar'}
              </button>
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleCancel}>
                Cancelar
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body">
          {loading ? (
            <div className="text-center py-4"><div className="spinner-border text-primary"></div></div>
          ) : (
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Color</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {types.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center text-muted py-4">No hay tipos registrados</td>
                  </tr>
                ) : (
                  types.map((type) => (
                    <tr key={type.id}>
                      <td><span className={`badge ${type.color}`}>{type.name}</span></td>
                      <td>{colors.find(c => c.value === type.color)?.label || type.color}</td>
                      <td>
                        <button className="btn btn-sm btn-outline-secondary mr-1" onClick={() => handleEdit(type)}>
                          <i className="ti-pencil"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(type.id)}>
                          <i className="ti-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityTypes;
